import { INIT_DB, UPDATE_PAGE, navigate, LOGIN } from "./actions/app.js";
import { loadInspection, unloadInspection, LOAD_INSPECTION, getUpdateInspectionPromise } from "./actions/inspection.js";
import { loadLocalInspections } from "./actions/local-inspections.js";
import { validateCurrentInspectionTab } from "./actions/validation.js";
import { computeParts, skippedTabs } from "./lib/helpers.js";
import { fetchNewInspections } from "./actions/new-inspections.js";

export const inspectionLoaderMiddleware = store => next => async action => {
	const prevState = store.getState();
	const result = next(action);
	const currState = store.getState();
	const route = currState.app.route;

	if (route.page === "inspection" && route.id != null) {
		await getUpdateInspectionPromise();

		switch (action.type) {
			case INIT_DB:
				store.dispatch(loadInspection());
				break;

			case UPDATE_PAGE:
				let promise = Promise.resolve();

				if (prevState.app.route.id != action.route.id) {
					promise = store.dispatch(loadInspection());
				}

				const shouldValidate = (
					prevState.app && prevState.app.route && prevState.app.route.subpage &&
                    action.route && action.route.subpage &&
                    prevState.app.route.subpage != action.route.subpage);
				if (shouldValidate) {
					const prevTabName = prevState.app.route.subpage;
					promise.then(() => store.dispatch(validateCurrentInspectionTab(prevTabName)));
				}
				break;

			case LOAD_INSPECTION:
				if (route.subpage == null && currState.inspection.current) {
					store.dispatch(navigate(getInspectionFirstTab(currState.inspection.current.type.schema)));
				}
				break;

			default:
				break;
		}
	}

	if (route.id == null && currState.inspection.current != undefined) {
		store.dispatch(unloadInspection());
	}

	if (currState.app.dbReady && route.page === "active-inspections" &&
        (action.type === INIT_DB || action.type === UPDATE_PAGE)) {
		store.dispatch(loadLocalInspections());
	}

	if (currState.app.dbReady && route.page === "new-inspections" &&
        (action.type === LOGIN)) {
		store.dispatch(fetchNewInspections());
	}

	if (action.type === LOGIN) {
		window.sync.postMessage({ name: "sync" });
	}

	return result;
};

export function getInspectionFirstTab(schema) {
	if (schema != undefined) {
		const parts = computeParts(schema);
		const tabs = parts.filter((p) => skippedTabs.indexOf(p.name) === -1);
		if (tabs.length > 0) {
			return tabs[0].name;
		}
	}
}
